var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"altStats"},[_c('div',{staticClass:"text"},[_vm._v("总共找到"+_vm._s(_vm.data.length)+"张图片")]),_c('div',{staticClass:"list"},[_c('data-list',{attrs:{"table-style":{ name: 'webclient' },"data":_vm.data,"columns":_vm.column,"height":300}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }